/**
 * Pricing table
 */

(function () {

  var pricing_modules = document.querySelectorAll('.js-pricing');
  if (pricing_modules.length > 0) {
    for (var i = 0; i < pricing_modules.length; i++) {

      var pricing = pricing_modules[i];
      var tabs = pricing.querySelectorAll('.js-pricing-tabs button');

      if (tabs.length > 0) {
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].addEventListener('click', function (e) {
            var allTabs      = e.currentTarget.parentNode.querySelectorAll('button');
            var allSections  = e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('.js-pricing-section');
            var selector     = e.currentTarget.getAttribute('aria-controls');
            for (var i = 0; i < allTabs.length; i++) {
              allTabs[i].setAttribute('aria-selected', 'false');
            }
            for (var i = 0; i < allSections.length; i++) {
              allSections[i].classList.remove('is-open');
            }
            e.currentTarget.setAttribute('aria-selected', 'true');
            var activeSection = document.getElementById(selector);
            if (activeSection) {
              activeSection.classList.add('is-open');
            }

          });
        }
      }

      if (tabs.length && tabs[0].classList) {
        tabs[0].click();
      }

      if (tabs.length == 1) {
        pricing.classList.add('has-one-tab');
      }

      pricing.classList.remove('is-rendering');
      pricing.classList.add('is-rendered');

    }
  }

}());
